import MoveNSeconds from '../MoveNSeconds'

const ForwardsNSeconds = MoveNSeconds(false)

export default ForwardsNSeconds
